<template>
  <div>
    <!-- this was created as a separate component because it will probably be reused in a modal -->
    <!-- TODO: obviously, all the markup -->
    <ValidationObserver ref="loginForm" slim>
      <b-form @submit.prevent="login" class="clearfix mb-3">
        <ValidationProvider
            name="Agency code"
            :rules="{ required: true }"
            v-slot="vContext"
          >
          <b-form-group
            :label="$gettext('Agency code')"
            label-class="font-weight-bold pt-0"
            label-for="agency"
            >
            <b-input
              type="text"
              name="Agency code"
              id="agency"
              v-model="credentials.client"
              :placeholder="$gettext('Agency code')"
              :state="getValidationState(vContext)"
              size="sm"
              aria-describedby="agency"/>
              <b-form-invalid-feedback id="agency">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="User name"
          :rules="{required: true}"
          v-slot="vContext"
        >
          <b-form-group
            :label="$gettext('Username')"
            label-class="font-weight-bold pt-0"
            label-for="numeAgent"
          >
            <b-input
              type="text"
              name="numeAgent"
              id="numeAgent"
              v-model="credentials.username"
              :placeholder="$gettext('Username')"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="agentName" />
            <b-form-invalid-feedback id="agentName">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="Parola"
          :rules="{required: true}"
          v-slot="vContext"
        >
          <b-form-group
            :label="$gettext('Password')"
            label-class="font-weight-bold pt-0"
            label-for="password">
            <b-input
              type="password"
              name="password"
              id="password"
              v-model="credentials.password"
              :placeholder="$gettext('Password')"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="password" />
            <b-form-invalid-feedback id="password">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <hr>
        <b-button type="submit" variant="primary" class="btn-block"> <b-icon icon="lock" font-scale=".9" class="mr-2"/><translate>Log in</translate></b-button>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'

export default {
  name: 'Login',
  mixins: [validation, toast],
  data () {
    return {
      credentials: {
        client: '',
        username: '',
        password: ''
      }
    }
  },
  methods: {
    login () {
      this.$refs.loginForm.validate().then(success => {
        if (!success) {
          this.addToast({
            title: this.$gettext('Invalid form'),
            message: this.$gettext('Please fill in all required fields!'),
            variant: 'danger'
          })
        } else {
          this.$emit('login', this.credentials)
        }
      })
    }
  }
}
</script>

<style  scoped>
a.link{
  cursor: pointer;
  color:blue;
}
a.link:hover{
  text-decoration: underline!important;
}
</style>
